import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

type Props = {
  classes: Object,
  className: string,
};

const BlogGridWrapper = ({ classes, children, posts }: Props) => {
  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.smallMaxWidth]: posts && posts.length === 1,
        [classes.midMaxWidth]: posts && posts.length === 2,
        [classes.largeMaxWidth]: posts && posts.length >= 3,
      })}
    >
      {children}
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    margin: "0 auto",
    padding: "40px 12px",

    [theme.breakpoints(600)]: {
      padding: "48px 60px",
    },
  },
  smallMaxWidth: {
    maxWidth: "540px",
  },
  midMaxWidth: {
    maxWidth: "900px",
  },
  largeMaxWidth: {
    maxWidth: "1292px",
  },
}))(BlogGridWrapper);
